import React from 'react'
import { CButton, CCard, CCardBody, CCol, CRow } from '@coreui/react'
import WidgetsReminderUserConfig from '../widgets/WidgetsReminderUserConfig'
import { useNavigate } from 'react-router-dom'

const Wizard = () => {
  let navigate = useNavigate()

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={12}>
              <div>
                <h1>.</h1>
              </div>
              <h4 id="traffic" className="card-title mb-0">
                <p id="caption 1">Reminder - Configuration Wizard - User definition</p>
              </h4>
            </CCol>
          </CRow>
          <CRow>{/*<WidgetsDropdown />*/}</CRow>
        </CCardBody>
      </CCard>
      <WidgetsReminderUserConfig />
      <CCard>
        <CCardBody>
          <CRow>
            <CCol sm={12}>
              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <CButton
                  color="primary"
                  onClick={() => {
                    //localStorage.removeItem('loginName1')
                    //localStorage.removeItem('wizard')
                    localStorage.setItem('wizard', 'User defined')
                    console.log('User Configuration finished')
                    console.log('User: ' + localStorage.getItem('account_ID'))
                    console.log('Gender: ' + localStorage.getItem('gender'))
                    console.log('Birthday: ' + localStorage.getItem('birthday'))
                    if (localStorage.getItem('gender') !== null) {
                      if (localStorage.getItem('birthday') !== null) {
                        console.log('NEXT Button pushed')
                        navigate('/wizard2')
                      }
                    }
                  }}
                >
                  NEXT
                </CButton>
              </div>
            </CCol>
          </CRow>
          <CRow>{/*<WidgetsDropdown />*/}</CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default Wizard
